/** leads/StartupTaxcutPage.tsx — 업력 3년 도래 임박 (창업벤처기업세액감면 §6 검토 대상)
 *  모수 = 벤처 미확인 신설법인 (지도사 확정 (B)안) — 명단 소스(크레탑 등) 확보 후 파서 연결.
 *  ★대상 요건(지도사 확정 2026-07-17): 청년 아닌 창업자(여 만34세 초과 / 남 만36세 초과 — 병역 2년 가산) × (①수도권과밀억제권역 내 ②수도권 내 비과밀 지역).
 *   남성 만35~36세 병역 미이행자는 실제 대상일 수 있어 '병역 확인 시 대상 가능' 플래그로 분리.
 *   그 외(청년·비수도권)는 벤처 없이도 §6 청년·일반 창업감면을 이미 적용 중 → 벤처확인 영업 실익 없음.
 *  판별 3등급: 🔴 제외(1년차 재무상태표 영업권 계상) / 🟡 승계 의심(설립연도 고매출·자산 과대) / 🟢 1차 통과.
 *  최종 확정은 등기부·크레탑 지도사 확인 — 시스템은 스크리닝 담당. */
import React from 'react';

interface Props { onToast: (m: string, t?: string) => void }

export default function StartupTaxcutPage(_props: Props) {
  return (
    <div>
      <div className="ce-chips">
        {['3주년 D-90 이내', 'D-180 이내', '1년 이내'].map((l, i) => (
          <button key={l} className={'ce-chip' + (i === 1 ? ' on' : '')} disabled title="명단 연결 후 활성화">{l}</button>
        ))}
        <span className="ce-total">설립 3년 도래 임박순 · 벤처확인 신청 데드라인 역산</span>
      </div>
      <div className="ce-bar">
        <input className="ce-inp" placeholder="업체명 검색" disabled />
        <select className="ce-sel" disabled><option>과밀억제권역 내</option></select>
        <select className="ce-sel" disabled><option>판별 등급 전체</option></select>
        <button className="ce-btn" disabled title="명단 연결 후 활성화">신설법인 명단 업로드 (준비 중)</button>
      </div>

      <div className="tx-target">
        <div className="h">🎯 대상 요건 — 벤처확인이 감면의 유일한 통로인 창업자만</div>
        <div className="d">
          <b>여성 만 34세 초과 · 남성 만 36세 초과</b>(창업 당시 · 남성은 병역 2년 가산) × <b>① 수도권과밀억제권역 내</b> 또는 <b>② 수도권 내 비과밀 지역</b> 소재.
          남성 만 35~36세는 병역 미이행 시 대상일 수 있어 [병역 확인] 플래그로 분리.
          그 외(만 34세 이하 청년 · 비수도권)는 벤처 없이도 §6 청년·일반 창업감면 기적용 → 영업 대상 제외.
          과밀억제권역 판별은 시군구 매핑(수도권정비계획법 별표1) — 남양주·시흥·인천 일부 동 단위 경계는 [주소 확인 필요] 플래그 분리.
        </div>
      </div>

      <div className="tx-grade">
        <div className="g red">
          <div className="h">🔴 제외</div>
          <div className="d">1년차 재무상태표에 <b>영업권</b> 계상 — 사업양수·법인전환 승계 증거 (금융위 재무상태표 API 자동 확인, 법인당 +1콜)</div>
        </div>
        <div className="g amber">
          <div className="h">🟡 승계 의심</div>
          <div className="d">설립연도 매출 임계값 초과 또는 자산/자본금 과대 — 포괄양수도 전환 패턴 (요약재무로 무료 판별 · 임계값 조정 가능)</div>
        </div>
        <div className="g teal">
          <div className="h">🟢 1차 통과</div>
          <div className="d">위 해당 없음 — §6 검토 대상. 최종 확정(폐업 후 재개 등 재무 외 배제사유)은 등기부·크레탑으로 지도사 확인</div>
        </div>
      </div>

      <div className="ce-empty">
        <div className="big">🏗</div>
        <div className="t1">신설법인 명단 연결 대기</div>
        <div className="t2">
          벤처 미확인 + 설립 3년 임박 법인이 모수입니다 — 벤처 명단 밖이라 별도 소스(크레탑 등)가 필요합니다.<br />
          명단 추출 시 필수 4개 필드: <b>법인명 · 설립일 · 소재지(시군구까지) · 대표자 생년(월일) · 성별</b> — 생년 누락 시 '연령 미상' 그룹으로 분리되어 수동 확인이 늘어납니다.<br />
          파일을 주시면 헤더에 맞춰 파서를 연결하고, 3주년 D-day·대상 요건 필터·판별 등급·FP 배정까지 이 화면에서 가동됩니다.
        </div>
      </div>
    </div>
  );
}
